export default class UserModel {
    Id: number;
    Discriminator: string;
    FullName: string; 
    UserName: string; 
    NormalizedUserName: string; 
    Password: string;
    ConfirmPassword: string;
    Email: string; 
    NormalizedEmail: string; 
    EmailConfirmed: string; 
    SecurityStamp: string; 
    ConcurrencyStamp: string; 
    PhoneNumber: string; 
    PhoneNumberConfirmed: string; 
    TwoFactorEnabled: string; 
    LockoutEnd: string; 
    LockoutEnabled: string; 
    AccessFailedCount: string;
    CompanyId: number;
    RoleId: number;
    DefaultModuleId: number
    RoleName: string;
    DefaultModuleName: string;
}
